import { useNavigate } from 'react-router-dom';

import { useAuthStore } from '../stores/authStore';
import { useTransitionLoader } from '../stores/transitionLoaderStore';

export function AdminViewToggle() {
  const user = useAuthStore(s => s.user);
  const previewSegment = useAuthStore(s => s.previewSegment);
  const setPreviewSegment = useAuthStore(s => s.setPreviewSegment);
  const showTransition = useTransitionLoader(s => s.show);
  const navigate = useNavigate();

  if (user?.user_role !== 'ADMIN') {return null;}

  const isPreviewing = previewSegment === 'accountant';
  const label = isPreviewing ? 'Exit Accountant View' : 'View as Accountant';

  const handleClick = () => {
    if (isPreviewing) {
      showTransition(() => {
        setPreviewSegment(null);
        navigate('/dashboard');
      });
    } else {
      showTransition(() => {
        setPreviewSegment('accountant');
        navigate('/accountant');
      });
    }
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      className="fixed bottom-4 right-4 z-50 bg-surface-subtle border border-border text-txt-secondary text-xs px-3 py-1.5 shadow-sm hover:bg-surface-hover cursor-pointer"
    >
      {label}
    </button>
  );
}
